import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation, useNavigationType } from 'react-router-dom';
import './App.css';
import AppContent from './components/AppContent';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;